import { version } from "../../package.json"

export default{
    state:{ 
        versionapp:version
    },
    getters:{
        getVersionApp(state){
            return state.versionapp
        }
    }
}